import { request } from '../../libs/request'
import {
  CreateIdeaPayload,
  Idea,
  IdeasResponse,
  IdeaStatus,
  LikeVote,
} from './types'

const IDEAS_URL = '/idea'

export const getIdeas = async (page: number, limit: number) => {
  const response = await request<IdeasResponse>({
    method: 'GET',
    url: IDEAS_URL,
    query: {
      page: String(page),
      limit: String(limit),
      order: '-createdAt',
    },
  })

  return response.body
}

export const createIdea = async (payload: CreateIdeaPayload) => {
  const response = await request<Idea>({
    method: 'POST',
    url: IDEAS_URL,
    body: payload,
  })

  return response.body
}

export const voteForIdea = async (ideaId: string, vote: LikeVote | null) => {
  const response = await request<Idea>({
    method: 'POST',
    url: `${IDEAS_URL}/${ideaId}/vote`,
    body: { vote },
  })

  return response.body
}

export const changeIdeaStatus = async (
  ideaId: string,
  status: IdeaStatus,
) => {
  const response = await request<Idea>({
    method: 'POST',
    url: `${IDEAS_URL}/${ideaId}/status`,
    body: { status },
  })

  return response.body
}
